let lastActivity = Date.now();

export const updateLastActivity = () => {
  lastActivity = Date.now();
};

export const getLastActivity = () => lastActivity;
